import { NgModule } from '@angular/core';

// import { AngularFireAuthModule } from '@angular/fire/auth';

import { Login2Module } from 'app/authentication/login-2/login-2.module';
import { Register2Module } from 'app/authentication/register-2/register-2.module';
// import { ForgotPassword2Module } from 'app/authentication/forgot-password-2/forgot-password-2.module';
// import { ResetPassword2Module } from 'app/authentication/reset-password-2/reset-password-2.module';
// import { LockModule } from 'app/authentication/lock/lock.module';
// import { MailConfirmModule } from 'app/authentication/mail-confirm/mail-confirm.module';

// Service
import { CategoriesExpensesService } from "app/main/gastos/categories-expenses/categories-expenses.service";

@NgModule({
    imports: [
        Login2Module,
        Register2Module,
        // ForgotPassword2Module,
        // ResetPassword2Module,
        // LockModule,
        // MailConfirmModule,
        // AngularFireAuthModule
    ],
    providers: [
        CategoriesExpensesService
    ]
})
export class AuthenticationModule
{

}
